






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Insured } from '@/modules/Insured/interfaces/insured'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class InsuredDetailAdditional extends Vue {
  @Prop({ type: Object as () => Insured }) readonly insured!: Insured
}
